import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

// Keep-alive ping every 10 minutes to prevent Railway cold starts
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
setInterval(() => { fetch(`${API_URL}/api/health`).catch(() => {}); }, 600000);
